export default {
  validate(formData) {
    const errors = {};

    if (!formData.business?.businessName?.trim()) {
      errors.business_businessName = 'Business Name is required';
    }
    if (!formData.business?.businessAddress?.trim()) {
      errors.business_businessAddress = 'Business Address is required';
    }
    if (!formData.business?.businessTel?.trim()) {
      errors.business_businessTel = 'Business Tel. No is required';
    }
    if (!formData.jobAddress?.jobName?.trim()) {
      errors.jobAddress_jobName = 'Name is required';
    }
    if (!formData.jobAddress?.jobAddress?.trim()) {
      errors.jobAddress_jobAddress = 'Address is required';
    }
    if (!formData.jobAddress?.jobTel?.trim()) {
      errors.jobAddress_jobTel = 'Tel. No is required';
    }
    if (!formData.vesselDetails?.make?.trim()) {
      errors.vesselDetails_make = 'Make is required';
    }
    if (!formData.vesselDetails?.model?.trim()) {
      errors.vesselDetails_model = 'Model is required';
    }
    if (!formData.vesselDetails?.location?.trim()) {
      errors.vesselDetails_location = 'Location is required';
    }
    if (!formData.vesselDetails?.makersWarningLabel?.trim()) {
      errors.vesselDetails_makersWarningLabel = 'Is a Makers warning label attached? is required';
    }
    if (!formData.vesselDetails?.scaleReducerFitted?.trim()) {
      errors.vesselDetails_scaleReducerFitted = 'Has a scale reducer been fitted? is required';
    }
    if (!formData.vesselDetails?.capacity?.trim()) {
      errors.vesselDetails_capacity = 'Capacity (Ltrs) is required';
    }
    if (!formData.heatSource?.heatSourceType?.trim()) {
      errors.heatSource_heatSourceType = 'Direct or Indirect? is required';
    }
    if (!formData.heatSource?.gasBoilerType?.trim()) {
      errors.heatSource_gasBoilerType = 'Gas Boiler and/or Solar or Immersion Heaters is required';
    }
    if (!formData.installing?.inletWaterPressureFlowRate?.trim()) {
      errors.installing_inletWaterPressureFlowRate = 'Inlet water pressure &amp; flow rate is required';
    }
    if (!formData.commissioning?.fullyCommissioned?.trim()) {
      errors.commissioning_fullyCommissioned = 'Fully commissioned? is required';
    }
    if (!formData.operatingDetails1?.systemOperatingPressure?.trim()) {
      errors.operatingDetails1_systemOperatingPressure = 'System operating pressure (Bar) is required';
    }
    if (!formData.operatingDetails1?.operatingPressureExpansionVessel?.trim()) {
      errors.operatingDetails1_operatingPressureExpansionVessel = 'Operating pressure of expansion vessel (Bar) is required';
    }
    if (!formData.operatingDetails1?.operatingPressureExpansionValve?.trim()) {
      errors.operatingDetails1_operatingPressureExpansionValve = 'Operating pressure of expansion valve (Bar) is required';
    }
    if (!formData.operatingDetails1?.operatingTempReliefValve?.trim()) {
      errors.operatingDetails1_operatingTempReliefValve = 'Operating temperature of temperature relief valve or Operating temperature and pressure of combined temperature and pressure relief valve (°C or °C/Bar) is required';
    }
    if (!formData.operatingDetails1?.maxPrimaryCircuitPressureFlow?.trim()) {
      errors.operatingDetails1_maxPrimaryCircuitPressureFlow = 'Maximum primary circuit pressure and flow temperature (indirectly heated vessel) (Bar/°C) is required';
    }
    if (!formData.operatingDetails2?.nominalSizeD1?.trim()) {
      errors.operatingDetails2_nominalSizeD1 = 'Nominal size of D1 (mm) is required';
    }
    if (!formData.operatingDetails2?.lengthD1?.trim()) {
      errors.operatingDetails2_lengthD1 = 'Length of D1 (mm) is required';
    }
    if (!formData.operatingDetails2?.numberOfDischarges?.trim()) {
      errors.operatingDetails2_numberOfDischarges = 'Number of discharges is required';
    }
    if (!formData.operatingDetails2?.tundishSameLocation?.trim()) {
      errors.operatingDetails2_tundishSameLocation = 'Is tundish installed within the same location as the hot water storage vessel? is required';
    }
    if (!formData.operatingDetails2?.tundishVisible?.trim()) {
      errors.operatingDetails2_tundishVisible = 'Is the tundish visible? is required';
    }
    if (!formData.operatingDetails2?.automaticMeansIdentifying?.trim()) {
      errors.operatingDetails2_automaticMeansIdentifying = 'Are automatic means of identifying discharge installed? is required';
    }
    if (!formData.dischargePipework?.nominalSizeD2?.trim()) {
      errors.dischargePipework_nominalSizeD2 = 'Nominal size of D2 (mm) is required';
    }
    if (!formData.dischargePipework?.pipeworkMaterial?.trim()) {
      errors.dischargePipework_pipeworkMaterial = 'Pipework material is required';
    }
    if (!formData.dischargePipework?.pipeworkMinVerticalLength?.trim()) {
      errors.dischargePipework_pipeworkMinVerticalLength = 'Does pipework have a minimum vertical length of 300mm from tundish? is required';
    }
    if (!formData.dischargePipework?.pipeworkFallContinuously?.trim()) {
      errors.dischargePipework_pipeworkFallContinuously = 'Does the pipework fall continuously to point of termination? is required';
    }
    if (!formData.dischargePipework?.methodOfTermination?.trim()) {
      errors.dischargePipework_methodOfTermination = 'Method of termination? (gully, low level, soil stack or high level) is required';
    }
    if (!formData.dischargePipework?.terminationSatisfactory?.trim()) {
      errors.dischargePipework_terminationSatisfactory = 'Is the method of termination satisfactory? is required';
    }
    if (!formData.workCarriedOut?.workCarriedOut?.trim()) {
      errors.workCarriedOut_workCarriedOut = 'Work Carried Out is required';
    }
    if (!formData.receivedBy?.receivedByName?.trim()) {
      errors.receivedBy_receivedByName = 'Print Name is required';
    }
    if (!formData.receivedBy?.receivedByDate?.trim()) {
      errors.receivedBy_receivedByDate = 'Date is required';
    }
    if (!formData.issuedBy?.engineerSignature?.trim()) {
      errors.issuedBy_engineerSignature = 'Signature is required';
    }
    if (!formData.issuedBy?.issuedByDate?.trim()) {
      errors.issuedBy_issuedByDate = 'Date is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
};
